import { useEffect, useRef } from 'react'
import { useIdle, useInterval } from 'react-use'
import { ampli } from '@/utils/ampli'

type UseDwellTime = (
  callbackFn: (dwellTime: number, isPageHideTrigger: boolean) => void,
  open?: boolean,
) => void

const useExitPageDwellTime: UseDwellTime = (callbackFn, open = true) => {
  const isIdle = useIdle(60000)
  const secondCountRef = useRef(0)
  const pageVisibleRef = useRef(true)

  useInterval(
    () => {
      secondCountRef.current += 1
    },
    open && !isIdle && pageVisibleRef.current ? 1000 : null,
  )

  useEffect(() => {
    const handlePageHide = (event: PageTransitionEvent): void => {
      if (!event.persisted) {
        ampli.client.setTransport('beacon')
        callbackFn(secondCountRef.current, true)
        ampli.client.flush()
      }
    }

    const handleVisibilityChange = (): void => {
      pageVisibleRef.current = document.visibilityState === 'visible'
    }

    window.addEventListener('pagehide', handlePageHide)
    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      window.removeEventListener('pagehide', handlePageHide)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [callbackFn])

  useEffect(() => {
    if (!open) {
      callbackFn(secondCountRef.current, false)
      secondCountRef.current = 0
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open])
}

export default useExitPageDwellTime
